// extracted by mini-css-extract-plugin
module.exports = {"root":"components-ui-tabitem-root","active":"components-ui-tabitem-active"};